module.exports = __webpack_public_path__ + "img/domain_model.072807af.png";